import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DataModelService } from '../../../../../services/datamodel.service';

@Component({
    selector: 'paging-mapping',
    templateUrl: 'paging.mapping.html',
    styleUrls:['paging.mapping.css']
})
export class PagingMappingForm {

    //#region SelectedItem
    SelectedItemValue;
    @Input()
    get SelectedItem() {
        return this.SelectedItemValue;
    }
    set SelectedItem(val) {
        this.SelectedItemValue = val;
        this.SelectedItemChange.emit(this.SelectedItemValue);
    }

    @Output() SelectedItemChange = new EventEmitter<any>();
    //#endregion

    @Output() ValuesChanged = new EventEmitter<any>();

    Variables = [
        { Name: 'StartRow' },
        { Name: 'EndRow' },
        { Name: 'Top' }
    ]

    constructor(private _translate: TranslateService, private _dataModelService: DataModelService) {
    }

    ItemValuesChanged() {
        this.ValuesChanged.emit();
    }
}